import React from 'react';
import {Helmet} from "react-helmet";
import Banner from "./section/Banner";
import './home.css';
import LastEvent from "./section/LastEvent";
import AboutUs from "../AboutUs/AboutUs";
import ProgramsSection from "./section/ProgramsSection";
import Customer from "./section/Customer";
import OurTarget from "./section/OurTarget";

const Home = () => {

    return (

        <>
            {/*<Loading/>*/}
            <Helmet>
                <title>Shadzi-Happiness</title>
            </Helmet>
            <Banner/>
            {/*body*/}
            <LastEvent/>
            <div id={'about_us'} style={{width: '95%', margin: 'auto'}}>
                <AboutUs/>
            </div>
            <ProgramsSection/>
            <OurTarget/>
            <Customer/>

        </>
    );
};

export default Home;

